import React, { useEffect,memo } from "react";
import TeaxtareaField from "../../../components/formElements/TeaxtareaField";

import { useStateList } from "./HandleInvoiceStateProvider";
import { Box } from "@mui/material";
function Description({
  
  labelName,
  Type,
}) {
  
    const {
     
      data,
      setData,
      totNetAmt,
      viewMode,
      setInitialState,
      invoiceEntry,
      items,
      nonItems
      
    } = useStateList();
    const handleRemarksChange = (e) => {
      const value = e.target.value;
    
      if (value.length > 250) {
        setData((prev) => ({
          ...prev,
          remarks: value,
          errorStatus: {
            ...prev.errorStatus,
            remarks: true,
          },
          errorFields: {
            ...prev.errorFields,
            remarks: "Description must be less than 250 characters",
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          remarks: value,
          errorStatus: {
            ...prev.errorStatus,
            remarks: false,
          },
          errorFields: {
            ...prev.errorFields,
            remarks: "",
          },
        }));
      }
    };
    
    const handleRemarksKeyDown = (e) => {
      if(totNetAmt==0 &&  e.key === "Tab" && e.shiftKey) {
       
        e.preventDefault();
        e.stopPropagation();
        const updatedTableArr = [...items];
        const zeroItemIndex =
          updatedTableArr.findIndex((row) => row.itemCode.value === "") !== -1
            ? updatedTableArr.findIndex((row) => row.itemCode.value === "")
            : updatedTableArr.findIndex((row) => row.itemCode.value !== "");
            const updatedNonTableArr = [...nonItems];
            const zeroNonItemIndex =
            updatedNonTableArr.findIndex((row) => row.ledgerAccount.value === "") !== -1
                ? updatedNonTableArr.findIndex((row) => row.ledgerAccount.value === "")
                : updatedNonTableArr.findIndex((row) => row.ledgerAccount.value !== "");
    
        let element =Type==="Pos"? "itemCode" + zeroItemIndex:"ledgerAccount"+zeroNonItemIndex;
         
         element= document.getElementById(element)
        element.focus();
      }else{
      if (e.key === "Enter" || e.key === "Tab") {
        const element = document.getElementById("fileInput");
        element?.focus();
      }
    }
    };
  function getDescription(invoiceEntry) {
    if (invoiceEntry?.length !== 0) {
      let remark = "";
      if (Type === "CreditNote" || Type === "DebitNote") {
        remark =
          invoiceEntry?.relatedcrdrnotedetails?.[0]?.comments;
      } else {
        remark = invoiceEntry?.comments;
      }

      setData((prev) => ({
        ...prev,
        remarks: remark,
      }));
      setInitialState((prev) => ({
        ...prev,
        remarks: remark,
      }));
      
    }
  }
  useEffect(() => {
    getDescription(invoiceEntry);
  }, [invoiceEntry]);
  return (
    <Box
    className={viewMode == true ? "disable-interactions" : ""}>
      <TeaxtareaField       
        name="remarks"
        id="remarks"
        placeholder={labelName}
        size="small"
        fullWidth
        disable={viewMode == true || data?.partyName?.value === "" ? true : false}
        state={data}
        value={data.remarks}
        onKeyDown={handleRemarksKeyDown}
        onChange={handleRemarksChange}
        rows={8}
      />
    </Box>
  );
}

export default memo(Description);
